import { useEffect, useState } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { modelMicrositeService } from '~/components/organisms/previewBar/model-data';
import { QR_CODE_BUILDER_CREATED_ID_PARAM_NAME } from '~/constants/qr-code';
import { useAppDispatch } from '~/hooks/useRedux';
import { listOfLinksSlice } from '~/store/reducers/previewScreens/list-of-links';
import { getListOfLinksReducer } from '~/store/reducers/previewScreens/list-of-links/selectors';
import { getQrCodeReducerData } from '~/store/reducers/qr-code/selectors';

import { LIST_OF_LINKS_TEMPLATE_0 } from './components/LIST_OF_LINKS_TEMPLATE_0';
import { LIST_OF_LINKS_TEMPLATE_1 } from './components/LIST_OF_LINKS_TEMPLATE_1';
import { LIST_OF_LINKS_TEMPLATE_2 } from './components/LIST_OF_LINKS_TEMPLATE_2';
import { LIST_OF_LINKS_TEMPLATE_3 } from './components/LIST_OF_LINKS_TEMPLATE_3';
import { LIST_OF_LINKS_TEMPLATE_4 } from './components/LIST_OF_LINKS_TEMPLATE_4';
import { LIST_OF_LINKS_TEMPLATE_5 } from './components/LIST_OF_LINKS_TEMPLATE_5';
import { LIST_OF_LINKS_TEMPLATE_6 } from './components/LIST_OF_LINKS_TEMPLATE_6';
import { LIST_OF_LINKS_TEMPLATE_7 } from './components/LIST_OF_LINKS_TEMPLATE_7';
import { LIST_OF_LINKS_TEMPLATE_8 } from './components/LIST_OF_LINKS_TEMPLATE_8';
import { setBasicDefaultStyles } from './utils';

const { actions } = listOfLinksSlice;

export function ListOfLinksPreviewScreen() {
  const dispatch = useAppDispatch();

  const qrCodeState = useSelector(getQrCodeReducerData);
  const listOfLinksState = useSelector(getListOfLinksReducer, shallowEqual);

  const [searchParams] = useSearchParams();
  const createdId = searchParams.get(QR_CODE_BUILDER_CREATED_ID_PARAM_NAME) || null;

  const [stateTrigger, setStateTrigger] = useState(0);

  const selectedTemplate = listOfLinksState.selectedTemplate;
  const bgColors = listOfLinksState.bacgkroundColor;

  useEffect(() => {
    if (!createdId) {
      setBasicDefaultStyles(selectedTemplate, dispatch, actions, bgColors);
      setStateTrigger((prevTrigger) => prevTrigger + 1);
    }
  }, [selectedTemplate]);

  useEffect(() => {
    if (!listOfLinksState.micrositeData && stateTrigger && !createdId) {
      modelMicrositeService.listOfLinks(listOfLinksState, qrCodeState, { dispatch, actions }, true);
    }

    if (listOfLinksState.micrositeData && stateTrigger && !createdId) {
      modelMicrositeService.listOfLinks(
        listOfLinksState,
        qrCodeState,
        { dispatch, actions },
        false,
        listOfLinksState.micrositeData,
      );
    }

    if (createdId && !listOfLinksState.micrositeData?.id) {
      modelMicrositeService.listOfLinks(listOfLinksState, qrCodeState, { dispatch, actions }, true);
    }
  }, [stateTrigger]);

  switch (selectedTemplate) {
    case 0:
      return <LIST_OF_LINKS_TEMPLATE_0 />;
    case 1:
      return <LIST_OF_LINKS_TEMPLATE_1 />;
    case 2:
      return <LIST_OF_LINKS_TEMPLATE_2 />;
    case 3:
      return <LIST_OF_LINKS_TEMPLATE_3 />;
    case 4:
      return <LIST_OF_LINKS_TEMPLATE_4 />;
    case 5:
      return <LIST_OF_LINKS_TEMPLATE_5 />;
    case 6:
      return <LIST_OF_LINKS_TEMPLATE_6 />;
    case 7:
      return <LIST_OF_LINKS_TEMPLATE_7 />;
    case 8:
      return <LIST_OF_LINKS_TEMPLATE_8 />;
    default:
      return null;
  }
}
